import { defineComponent, inject, onUpdated } from 'vue';
import EmailInputClass from './EmailInput.class';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if (!store) throw new Error('incentiveV2Store was not provided');
		const component = new EmailInputClass(store);
		onUpdated(component.updated.bind(component));

		return setupComponent(component);
	},
});
